import Wysiwyg from './Wysiwyg';

const WysiwygDirective = (reactDirective, CreativeService) => {
  return reactDirective(
    Wysiwyg,
    undefined,
    {
      restrict: 'E'
    },
    {
      CreativeService
    }
  );
};

WysiwygDirective.$inject = ['reactDirective', 'CreativeService'];

export default WysiwygDirective;
